import {
    GET_ROOM_PRICES_LIST,
    GET_ROOM_PRICES_LIST_SUCCESS,
    CREATE_ROOM_PRICE,
    CREATE_ROOM_PRICE_SUCCESS,
    UPDATE_ROOM_PRICE,
    UPDATE_ROOM_PRICE_SUCCESS,
    DELETE_ROOM_PRICE,
    DELETE_ROOM_PRICE_SUCCESS,
    GET_ROOM_PRICE_BY_ID,
    GET_ROOM_PRICE_BY_ID_SUCCESS,
} from '../storeTypes';

export const ActionGetRoomPricesList = payload => {
    return {
        type: GET_ROOM_PRICES_LIST,
        payload,
    };
};

export const ActionGetRoomPricesListSuccess = payload => {
    return {
        type: GET_ROOM_PRICES_LIST_SUCCESS,
        payload,
    };
};

export const ActionCreateRoomPrice = (payload, callBack) => {
    return {
        type: CREATE_ROOM_PRICE,
        payload,
        callBack,
    };
};

export const ActionCreateRoomPriceSuccess = payload => {
    return {
        type: CREATE_ROOM_PRICE_SUCCESS,
        payload,
    };
};

export const ActionUpdateRoomPrice = (payload, callBack) => {
    return {
        type: UPDATE_ROOM_PRICE,
        payload,
        callBack,
    };
};

export const ActionUpdateRoomPriceSuccess = payload => {
    return {
        type: UPDATE_ROOM_PRICE_SUCCESS,
        payload,
    };
};

export const ActionDeleteRoomPrice = (payload, callBack) => {
    return {
        type: DELETE_ROOM_PRICE,
        payload,
        callBack,
    };
};

export const ActionDeleteRoomPriceSuccess = payload => {
    return {
        type: DELETE_ROOM_PRICE_SUCCESS,
        payload,
    };
};

export const ActionGetRoomPriceByID = (payload, callBack) => {
    return {
        type: GET_ROOM_PRICE_BY_ID,
        payload,
        callBack,
    };
};

export const ActionGetRoomPriceByIDSuccess = payload => {
    return {
        type: GET_ROOM_PRICE_BY_ID_SUCCESS,
        payload,
    };
};